import * as React from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { stepsForComponent } from "../../DummyData/DUMMYDATA";


const CustomStepIcon = styled("div")(({ ownerState, theme }) => ({
  backgroundColor:
    ownerState.completed || ownerState.active ? "#DB0035" : "#EDEAEA",
  zIndex: 2,
  color: ownerState.completed || ownerState.active ? "#FFFFFF" : "#000000",
  width: 37,
  height: 37,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  fontSize: 16,
  fontWeight: 700,
  position: "relative",
  flexShrink: 0,
  [theme.breakpoints.down("sm")]: {
    width: 32,
    height: 32,
    fontSize: 14,
  },
}));


const StepWrapper = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  flex: 1,
  minWidth: 0,
  
  "&:not(:last-child)::after": {
    content: '""',
    position: "absolute",
    top: "18.5px", 
    left: "37px", 
    right: "0px", 
    height: 3,
    backgroundColor: "#EDEAEA",
    zIndex: 1,
    [theme.breakpoints.down("sm")]: {
      top: "16px", 
      left: "32px", 
    },
  },
  
  "&.completed:not(:last-child)::after": {
    backgroundColor: "#DB0035",
  },
}));

export default function HorizontalLinearStepper({ activeStep }) {
  return (
    <Box
      sx={{
        width: "100%",
        marginTop: "74px",
        px: 0,
        overflowX: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          gap: 0, 
          minWidth: 0,
          position: "relative",
          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
      >
        {stepsForComponent.map((label, index) => {
          const isActive = index === activeStep;
          const isCompleted = index < activeStep;

          return (
            <StepWrapper
              key={label}
              className={`${isActive ? "active" : ""} ${
                isCompleted ? "completed" : ""
              }`}
              style={{
                flex: index === stepsForComponent.length - 1 ? "0 0 auto" : "1",
                minWidth: index === stepsForComponent.length - 1 ? "auto" : "60px",
              }}
            >
              <CustomStepIcon
                ownerState={{ completed: isCompleted, active: isActive }}
              >
                {index + 1}
              </CustomStepIcon>

              <Box
                sx={{
                  mt: { xs: 1, sm: 1.5, md: 2 },
                  width: "100%",
                  maxWidth: { xs: "50px", sm: "80px", md: "none" }, 
                }}
              >
                <Box
                  component="span"
                  sx={{
                    fontSize: { xs: 8, sm: 10, md: 12 }, 
                    lineHeight: { xs: "10px", sm: "12px", md: "16px" },
                    color: isActive ? "#DB0035" : "#000000",
                    wordBreak: "break-word",
                    fontWeight: isActive ? 700 : 400,
                    hyphens: "auto",
                    display: "block",
                    textAlign: "left",
                    overflow: "hidden", 
                    textOverflow: "ellipsis",
                  }}
                >
                  {label}
                </Box>
              </Box>
            </StepWrapper>
          );
        })}
      </Box>
    </Box>
  );
}